module.exports = __webpack_public_path__ + "img/desc1.59120f32.jpg";